<template>
    <div>
        <q-splitter v-model="splitterModel" :limits="[10, 25]" style="height:calc(100vh - 40px);">
            <sliding-tab class="noprint" :attributes="{ bgcolor:'WhiteSmoke', width:40, handleLabel:'school', handleTop:10 }">
                <div class="text-h6 text-left text-indigo-9 q-mt-md" style="white-space:normal !important;">Signification des symboles</div>
                <table>
                    <tr>
                        <th class="text-left">Note</th>
                        <th class="text-left">Signification</th>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray"><span style="color:#07f;">4,,,,</span><br /><span style="color:#07f;">4....</span></span></td>
                        <td class="underlined">Temps binaire. Chaque barre verticale (ou point) peut se prolonger par une note décrite ci-dessous. Si pas de note indiquée, ne rien jouer.</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray"><span style="color:#07f;">3,,,</span><br /><span style="color:#07f;">3...</span></span></td>
                        <td class="underlined">Temps ternaire. Même remarque que pour le binaire. Les barres verticales et les points ont la même signification.</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray"><span style="color:#07f;">[</span>4,,,,<span style="color:#07f;">]</span></span></td>
                        <td class="underlined">Les barres verticales indiquent une séquence qui ne se répette pas, telle qu'un appel.</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray"><span style="color:#07f;">:</span>4,,,,<span style="color:#07f;">;</span></span></td>
                        <td class="underlined">Les barres verticales pointées indiquent une séquence qui se répette, telle qu'un accompagnement.</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray">4<span style="color:#07f;">d</span>,<span style="color:#07f;">g</span>,<span style="color:#07f;">d</span>,<span style="color:#07f;">g</span>,</span></td>
                        <td class="underlined">Indique la main qui joue (d=droit, g=gauche, r=right, l=left)</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray">4,,<span style="color:#07f;">a</span>t,</span></td>
                        <td class="underlined">Anacrouse : indique le début de l'accompagnement, à synchoniser avec la fin de l'appel.</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray">4,,<span style="color:#07f;">*</span>t,</span></td>
                        <td class="underlined">L'astérisque au-dessus d'une note peut être utilisée pour donner des instructions particulières sur cette note.</td>
                    </tr>
                    <tr>
                        <th colspan="2">Notes spécifiques au djembé</th>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray"><span style="color:#07f;">b</span></span></td>
                        <td class="underlined">Basse ; "boum"</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray"><span style="color:#07f;">t</span></span></td>
                        <td class="underlined">Note tonique ; "to"</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray"><span style="color:#07f;">s</span></span></td>
                        <td class="underlined">Note claquée ; "ta" ou "slap"</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray"><span style="color:#07f;">u</span>s</span></td>
                        <td class="underlined">Claqué précédent la subdivision d'une fraction de seconde : c'est le premier coup du "fla"</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray"><span style="color:#07f;">w</span>s</span></td>
                        <td class="underlined">Idem, mais en tonique</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray"><span style="color:#07f;">q</span>s</span></td>
                        <td class="underlined">Idem, mais en basse</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray">3<span style="color:#07f;">_</span>b<span style="color:#07f;">_</span>t<span style="color:#07f;">_</span>s</span></td>
                        <td class="underlined">Notes étouffées</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray">3t<span style="color:#07f;">=i</span>tt</span></td>
                        <td class="underlined">Insertiton d'une tonique entre deux notes.</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray">3s<span style="color:#07f;">=j</span>ss</span></td>
                        <td class="underlined">Insertiton d'un claqué entre deux notes.</td>
                    </tr>
                    <tr>
                        <th colspan="2">Notes spécifiques aux douns</th>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray">3,<span style="color:#07f;">x</span>,,</span></td>
                        <td class="underlined">Coup de cloche</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray"><span style="color:#07f;">t</span></span></td>
                        <td class="underlined">Coup sur la peau, avec rebond</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray"><span style="color:#07f;">_t</span></span></td>
                        <td class="underlined">Coup sur la peau, sans rebond ; son étouffé</td>
                    </tr>
                    <tr>
                        <td class="underlined"><span class="p-music light-gray"><span style="color:#07f;">B</span></span></td>
                        <td class="underlined">Coup sur le bois ou le cerclage.</td>
                    </tr>
                </table>
            </sliding-tab>
            <template v-slot:before class="noprint"><!-- song list -->
                <q-toolbar class="bg-grey-3 text-primary noprint">
                    <q-toolbar-title >
                        <q-btn flat outline rounded icon="music_note" @click="getSongList">
                            <q-tooltip>
                                Rafraichir la liste
                            </q-tooltip>
                        </q-btn>
                    </q-toolbar-title>
                    <q-input v-model="song_filter" label="Filtre" dense class="noprint">
                        <template v-slot:prepend>
                            <q-icon name="visibility" />
                        </template>
                        <template v-slot:append>
                            <q-icon name="close" @click="song_filter = ''" class="cursor-pointer" />
                        </template>
                        <q-tooltip>
                            Montrer seulement les titres qui contiennent ce texte
                        </q-tooltip>
                    </q-input>
                    <q-btn v-if="currentuser" flat round dense class="text-primary noprint" icon="add_box" v-ripple @click="newSong()">
                        <q-tooltip>
                            Créer un nouveau titre
                        </q-tooltip>
                    </q-btn>
                </q-toolbar>
                <q-list bordered separator class="noprint">
                    <!-- q-item v-for="(titre, t_idx) in sortedFilteredSongs" :key="'titre_'+t_idx" clickable v-ripple @click="getSong(titre.id)" -->
                    <q-item v-for="(titre, t_idx) in sortedFilteredSongs" :key="'titre_'+t_idx" clickable v-ripple @click="gotoSongName(titre.title)">
                        <q-item-section>
                            <q-item-label class="text-h6 text-primary">{{ titre.title }}</q-item-label>
                            <q-item-label caption>
                                <strong>Auteur:</strong> {{ getAuthorName(titre.author) }}
                                - 
                                <strong>Dernière m-àj:</strong> {{ titre.updatedate }}
                                <span v-if="!titre.public && currentuser && (currentuser.email==titre.author || currentuser.admin)" class="text-negative text-bold">
                                    -
                                    Non publié!
                                </span>
                            </q-item-label>
                        </q-item-section>
                    </q-item>
                </q-list>
            </template>

            <template v-slot:after><!-- song details -->
                <div v-if="currentTitle.title != null" class="song-content">
                    <q-expansion-item v-if="currentuser && (currentuser.email==currentTitle.author || currentuser.admin)" expand-separator 
                        icon="edit" label="Editeur de partition" :disable="false" class="noprint">
                        <q-card>
                            <q-card-section>
                                <!-- toolbar -->
                                <q-toolbar class="text-primary bg-grey-3" style="border-bottom:1px solid #07f;">
                                    <q-toolbar-title>
                                        <q-input label="Nom de la partition" :dense="true" v-model="currentTitle.title" @change="canDelete=false">
                                        <q-tooltip>
                                            Le nom de la partition, tel qu'il apparaît dans la liste de gauche.
                                        </q-tooltip>
                                        </q-input>
                                    </q-toolbar-title>
                                    <!--  TODO : change ownership  -->
                                    <q-separator vertical inset color="primary" />
                                    <q-checkbox v-model="currentTitle.public" label="Partition publique" class="q-mr-sm">
                                        <q-tooltip>
                                            Une partition publique est visible par tout le monde.
                                        </q-tooltip>
                                    </q-checkbox>
                                    <q-separator vertical inset color="primary" />
                                    <q-btn flat round dense icon="school" @click="openDjembeSyntaxe()">
                                        <q-tooltip>
                                            Aide à la syntaxe
                                        </q-tooltip>
                                    </q-btn>
                                    <q-btn flat round dense icon="save" @click="saveSong">
                                        <q-tooltip>
                                            Sauver les modifications
                                        </q-tooltip>
                                    </q-btn>
                                    <q-btn flat round dense icon="delete" color="negative" @click="confirmDeletionDialog=true" :disable="!canDelete">
                                        <q-tooltip>
                                            Supprimer définitivement cette partition
                                        </q-tooltip>
                                    </q-btn>
                                </q-toolbar>
                                <!-- textarea -->
                                <q-input v-model="currentTitle.song" class="monospace" filled type="textarea" />
                            </q-card-section>
                        </q-card>
                    </q-expansion-item>
                    <q-separator style="flex:0 0 1px;" />
                    <div class="q-pa-md print-full-width">
                        <v-runtime-template :template="wikify()"></v-runtime-template>
                    </div>
                </div>
                <div v-else style="text-align:center;"><!-- djembefolla picture, if no song selected -->
                    <img src="@/assets/djembefolla.png" @click="play('t.tt .t.t t.ss s...', 1)" style="height:80vh; width:auto; margin-top:5vh; cursor:pointer;"/>
                        <q-tooltip>
                            Clique sur le djembéfolla pour entendre l'appel!
                        </q-tooltip>
                    </img>
                </div>
            </template>

        </q-splitter>
        <q-dialog v-model="confirmDeletionDialog" v-if="currentTitle.title != null" persistent><!-- deletion dialog -->
            <q-card style="min-width: 400px">
                <q-card-section>
                    <div class="text-h6">Pour supprimer ce titre, veuillez entrer son nom ({{ currentTitle.title }}). </div>
                </q-card-section>

                <q-card-section>
                    <q-input dense v-model="confirmDialogInput" autofocus @keyup.enter="deleteSong" />
                </q-card-section>

                <q-card-actions align="right" class="text-primary">
                    <q-btn flat label="GARDER" v-close-popup />
                    <q-btn flat label="SUPPRIMER" v-close-popup @click="deleteSong" />
                </q-card-actions>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
import firebase from '../firebase.js';
import { Notify } from 'quasar';
import {Howl, Howler} from 'howler';
import VRuntimeTemplate from "v-runtime-template";
import MyRythme from './Rythme.vue';
import SlidingTab from './SlidingTab.vue';
import { parseWiki } from '../assets/js/WikiParser.js';
import b_sound from '../assets/sounds/djembe-pou.wav';
import t_sound from '../assets/sounds/djembe-pi.wav';
import s_sound from '../assets/sounds/djembe-slap.wav';
import p_sound from '../assets/sounds/djembe_pof.wav';
import K_sound from '../assets/sounds/kenkeni.wav';
import S_sound from '../assets/sounds/sangban.wav';
import D_sound from '../assets/sounds/dunumba.wav';
import x_sound from '../assets/sounds/cloche.wav';

export default {
    name: 'Partitions',
    props: ['currentuser'],
    components: {
        VRuntimeTemplate,
        MyRythme,
        SlidingTab,
    },
    data () {
        return {
            db: firebase.firestore(),
            left: true,   // left drawer
            right: true,  // right drawer
            splitterModel: 20, // start at 50%
            confirmDeletionDialog: false,
            confirmDialogInput: '',
            canDelete: false,
            songlist: [],
            song_filter: '',
            userlist: {},
            currentTitle: { id: null, title: null, author: null, createdate:null, updatedate: null, public:null, song: null, },
            //
            sounds: {},
            // bpm: 70, => deplacé dans le store
            hpt: 4,   // hit per time (4=binaire, 3=ternaire)
        }
    },
    methods: {
        wikify: function(){
            const tmp = parseWiki(this.currentTitle.song)
            return tmp;
        },
        getUserList(){
            const self = this;
            self.db.collection("users").get().then(
                (querySnapshot) => {
                    self.userlist = {};
                    querySnapshot.forEach((doc) => {
                        // console.log(`adding user ${doc.id} in userlist => `, doc, doc.id, doc.data());
                        self.userlist[doc.data()['email']] = doc.data()['fname'] + ' ' + doc.data()['lname'][0] + '.';
                    });
                },
                (err) => {
                    console.log("ERROR getting the user list from firebase", err);
                    Notify.create({ message: "ERREUR: impossible de récupérer la liste des utilisateurs.", color: 'negative', timeout: 0 });
                }
            );
        },
        getAuthorName(author){
            return (this.userlist.hasOwnProperty(author)) ? this.userlist[author] : author;
        },
        getSongList(){
            let self = this;
            return new Promise(function(resolve, reject){
                // read from firebase
                let proms = []
                if (self.currentuser !== null){
                    if (self.currentuser.admin){
                        proms.push(self.db.collection("songs").get());
                    }
                    else{
                        proms.push(self.db.collection("songs").where("author", "==", self.currentuser.email).get());
                        proms.push(self.db.collection("songs").where("public", "==", true).get());
                    }
                }
                else{
                    proms.push(self.db.collection("songs").where("public", "==", true).get());
                }

                Promise.all(proms)
                .then(
                    function(values) {
                        // console.log("values", values);
                        self.songlist = [];
                        values.forEach((querySnapshot) => {
                            querySnapshot
                            .forEach(function(song) {
                                // doc.data() is never undefined for query doc snapshots
                                // console.log(song.id, " => ", song.data());
                                if (self.songlist.filter((part) => { return (part.id == song.id); }).length == 0){
                                    self.songlist.push(
                                        {
                                            author    : song.data()['author'],
                                            createdate: song.data()['createdate'],
                                            id        : song.id,
                                            title      : song.data()['title'],
                                            public    : song.data()['public'],
                                            updatedate: song.data()['lastupdate']
                                        }
                                    );
                                }
                            })
                        })
                        self.songlist = self.songlist.sort((a,b) => {
                            return (a.title.toLowerCase()<b.title.toLowerCase()) ? -1: 0;
                        });
                        resolve();
                    })
                .catch(
                    (err) => {
                        Notify.create({ message: "ERREUR: impossible de récupérer la liste des partitions.", color: 'negative', timeout: 0 });
                        reject(err);
                    }
                );
            });
        },
        songnameToSongid(songname){
            let lst = this.songlist.filter((el) => { return (el.title == songname); });
            if (lst.length > 0){
                return lst[0].id;
            }
            return null;
        },
        gotoSongName(songName){
            this.$router.push({ path: `/partitions/${songName}` });
        },
        getSong(songid){
            console.log("getSong(songid):", songid);
            let self = this;
            let songRef = self.db.collection("songs").doc(songid);
            songRef.get().then(function(song) {
                if (song.exists) {
                    self.currentTitle = {
                        id        : songid,
                        title     : song.data()['title'],
                        author    : song.data()['author'],
                        createdate: song.data()['createdate'],
                        updatedate: song.data()['lastupdate'],
                        public    : song.data()['public'],
                        song      : song.data()['song'],
                    };
                    self.canDelete = true;
                    // Notify.create({ message: "Partition '"+self.currentTitle.title+"' chargée.", color: 'positive' })
                }
                else {
                    Notify.create({ message: "Partition '"+self.currentTitle.title+"' non trouvée dans la base de données.", color: 'negative', timeout:0 })
                }
            }).catch(function(error) {
                Notify.create({ message: "Erreur lors du chargement de la partition '"+songid+"'.", color: 'negative', timeout: 0 });
                console.log("Error getting document:", error);
            });
        },
        rightNow(){
            let today_date = new Date();
            let today = (today_date.getYear() + 1900).toString() + '-' +
                        (today_date.getMonth() + 1).toString().padStart(2, '0') +  '-' +
                        today_date.getDate().toString().padStart(2, '0');
            return today;
        },
        saveSong(){
            let self = this;
            let songsref = self.db.collection("songs");
            if (!self.currentTitle.createdate){
                self.currentTitle.createdate = self.rightNow();
                self.currentTitle.updatedate = '';
            }
            else{
                self.currentTitle.updatedate = self.rightNow();
            }
            // songsref.doc(self.currentTitle.id)
            // console.log("self.currentTitle.id", self.currentTitle.id);
            songsref.doc(self.currentTitle.id)
                .set({
                    author    : self.currentTitle.author,
                    createdate: self.currentTitle.createdate,
                    lastupdate: self.currentTitle.updatedate,
                    public    : self.currentTitle.public,
                    song      : self.currentTitle.song,
                    title     : self.currentTitle.title
                })
                .then(function() {
                    Notify.create({ message: "Sauvegarde réussie.", color: 'primary' });
                    self.getSongList();
                })
                .catch(function(error) {
                    Notify.create({ message: "Problème rencontré lors de la sauvegarde.", color: 'negative', timeout: 0 });
                    console.error("Error writing document: ", error);
                });
        },
        newSong(){
            const self = this;
            self.currentTitle = 
                {
                    id        : new Date().getTime().toString(),
                    title     : "Nouveau titre",
                    author    : self.currentuser.email,
                    public    : false,
                    song      : "enter the song text here...",
                }
        },
        deleteSong(){
            const self = this;
            self.confirmDeletionDialog = false
            if (!self.currentTitle || self.currentTitle.title != self.confirmDialogInput){
                Notify.create({ message: "Mauvaise confirmation. Le titre '" + self.currentTitle.title + "' n'a PAS été supprimé.", color: 'warning', timeout: 0 });
                return;
            }
            let songName = self.currentTitle.title;
            self.db.collection('songs')
                .doc(self.currentTitle.id)
                .delete()
                .then(
                    () => { 
                        Notify.create({ message: "Le titre '" + self.currentTitle.title + "' a été supprimé.", color: 'positive' });
                        // update the song list
                        const idx = self.songlist.findIndex((el) => { return (el.title === songName); });
                        if (idx > -1){
                            self.songlist.splice(idx, 1);
                        }
                        self.currentTitle = { id: null, title: null, author: null, createdate:null, updatedate: null, public:null, song: null };
                        self.confirmDialogInput = "";
                    }, 
                    (err) => {
                        Notify.create({ message: "ERREUR: le titre '" + songName + "' n'a pas pu être supprimé.", color: 'positive', timeout: 0 });
                        console.log("ERROR", err);
                    }
                )
        },
        interval(idx){
            return this.dureeIntervale * idx;
        },
        play(notes, times){
            const self = this;
            /* known sounds:
                t        : to
                s        : ta
                b        : bass
                T        : coup faible sur la peau (duns seulement)
                B        : coup sur le bois ou cerclage (duns seulement)
                x        : coup de cloche (duns seulement)
                _t => p  : to étouffé
                _s => l  : ta étouffé
                f  => f  : ta-ta (flam)   en t*.9
                =i => i  : to             en t/2
                =j => j  : ta             en t/2
                qt => q  : bass-to        en t*.9
                qs => r  : bass-ta        en t*.9
                qb => p  : bass-bass      en t*.9
                ut => u  : ta-to          en t*.9
                us => f  : ta-ta          en t*.9
                ub => v  : ta-bass        en t*.9
                wt => w  : to-to          en t*.9
                ws => x  : to-ta          en t*.9
                wb => y  : to-bass        en t*.9

                used letters:
                abcdefghijklmnopqrstuvwxyz ABCDEFGHILKLMNOPQRSTUVWXYZ 0123456789
                x  x  x xx x x xxxxxx xx    x x      x       x           xx
            */
            let temp = notes.replace(new RegExp(/[ lrgdac34=]/, 'g'), '') // remove cosmetic characters
            temp = temp.replace(new RegExp(/,/, 'g'), '.') // replace all commas by dots
            temp = temp.replace(new RegExp(/_t/, 'g'), 'p') // 
            temp = temp.replace(new RegExp(/_s/, 'g'), 'p') //  they both refer to the same sound, as I have only one in my samplings :-(
            temp = temp.replace(new RegExp(/f/, 'g'), 'us') // 
            temp = temp.replace(new RegExp(/=i/, 'g'), 'i') // 
            temp = temp.replace(new RegExp(/=j/, 'g'), 'j') // 
            temp = temp.replace(new RegExp(/-K/, 'g'), 'L') // 
            temp = temp.replace(new RegExp(/-D/, 'g'), 'M') // 
            temp = temp.replace(new RegExp(/-S/, 'g'), 'N') // 
            temp = temp.replace(new RegExp(/[ nTBl]/, 'g'), '') // pas encore supportés
            temp = temp.repeat(times) // duplicate the sequence according to the number of times to play
            
            if (self.$store.state.appel){
                temp = self.$store.state.appel + temp
            }
            console.log('temp', temp)

            let idx = 0;
            let quand = 0;
            temp.split('').forEach(
                function(note){
                    let snd = '';
                    if (note=='b') snd = 'b';
                    if (note=='i') snd = 't';
                    if (note=='j') snd = 's';
                    if (note=='p') snd = 'p';
                    if (note=='q') snd = 'b';
                    if (note=='s') snd = 's';
                    if (note=='t') snd = 't';
                    if (note=='u') snd = 's';
                    if (note=='w') snd = 't';
                    if (note=='x') snd = 'x';
                    if (note=='D') snd = 'D';
                    if (note=='S') snd = 'S';
                    if (note=='K') snd = 'K';
                    if (note=='M') snd = 'D';
                    if (note=='N') snd = 'S';
                    if (note=='L') snd = 'K';
                    let elapsed = 0
                    if (['i', 'j'].indexOf(note) > -1){
                        elapsed += self.dureeIntervale / 2
                    }
                    else if (['u', 'q', 'w'].indexOf(note) > -1){
                        elapsed += self.dureeIntervale * .9
                    }
                    else if (['L', 'M', 'N'].indexOf(note) > -1){ // to make sure both suns are audible
                        elapsed += self.dureeIntervale * .95
                    }
                    else {
                        elapsed += self.dureeIntervale;
                    }
                    if (snd){
                        setTimeout(() => {
                            self.sounds[snd].play();
                            }, quand + elapsed
                        )
                    }
                    if (['b', 't', 's', '.', 'p', 'D', 'S', 'K'].indexOf(note) > -1){
                        quand += self.dureeIntervale;
                    }
                }
            );
        },
        openDjembeSyntaxe(){
            let routeData = this.$router.resolve({name: 'writesyntaxhelp'});
            window.open(routeData.href, '_blank');
            // window.open("/djembe_syntaxe.html", "djembe_syntaxe",);
        },
    },
    computed: {
        filteredSongs: function(){
            const self = this;
            let filter = self.song_filter.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            if (self.song_filter.length > 1){
                return self.songlist.filter((song) => {
                    return song.title.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").match(filter);
                });
            }
            else{
                return self.songlist; 
            }
        },
        sortedFilteredSongs: function(){
            return this.filteredSongs.sort(
                (a,b) => { 
                    let at = a.title.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                    let bt = b.title.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                    return (at < bt) ? -1 : 1; }
            );
        },
        dureeIntervale: function() { // utilisé pour établir le tempo
            return 1000 / (this.hpt * this.$store.state.bpm / 60) ;
        },
    },
    watch: {
        currentuser: function(){
            this.getSongList();
        },
        '$route': function(to, from){
            // console.log("watch on $route:", from, to);
            // load song in the right panel
            let songid = this.songnameToSongid(to.params.partid);
            if (songid){
                this.getSong(songid);
            }
        },
    },
    created(){
        { // load sounds
            this.sounds.b = new Howl({ 
                // src: ['../assets/sounds/djembe-pou.wav'], 
                src: [b_sound], 
                onloaderror: function(id, err){ 
                    console.log("sound load error", err);
                    Notify.create({ message: "ERREUR: impossible de charger le son 'BOUM'.", color: 'negative', timeout: 0 });
                }
            });
            this.sounds.t = new Howl({ 
                //src: ['@/assets/sounds/djembe-pi-2.wav'], 
                src: [t_sound], 
                onloaderror: function(id, err){ 
                    Notify.create({ message: "ERREUR: impossible de charger le son 'TO'.", color: 'negative', timeout: 0 });
                    console.log("sound load error", err); 
                }
            });
            this.sounds.s = new Howl({ 
                // src: ['@/assets/sounds/djembe-slap.wav'], 
                src: [s_sound], 
                onloaderror: function(id, err){ 
                    Notify.create({ message: "ERREUR: impossible de charger le son 'TA'.", color: 'negative', timeout: 0 });
                    console.log("sound load error", err);
                }
            });
            this.sounds.p = new Howl({ 
                src: [p_sound], 
                onloaderror: function(id, err){ 
                    Notify.create({ message: "ERREUR: impossible de charger le son 'POF'.", color: 'negative', timeout: 0 });
                    console.log("sound load error", err);
                }
            });
            this.sounds.K = new Howl({ 
                src: [K_sound], 
                onloaderror: function(id, err){ 
                    Notify.create({ message: "ERREUR: impossible de charger le son 'Kenkeni'.", color: 'negative', timeout: 0 });
                    console.log("sound load error", err);
                }
            });
            this.sounds.S = new Howl({ 
                src: [S_sound], 
                onloaderror: function(id, err){ 
                    Notify.create({ message: "ERREUR: impossible de charger le son 'sangban'.", color: 'negative', timeout: 0 });
                    console.log("sound load error", err);
                }
            });
            this.sounds.D = new Howl({ 
                src: [D_sound], 
                onloaderror: function(id, err){ 
                    Notify.create({ message: "ERREUR: impossible de charger le son 'dunumba'.", color: 'negative', timeout: 0 });
                    console.log("sound load error", err);
                }
            });
            this.sounds.x = new Howl({ 
                src: [x_sound], 
                onloaderror: function(id, err){ 
                    Notify.create({ message: "ERREUR: impossible de charger le son 'cloche'.", color: 'negative', timeout: 0 });
                    console.log("sound load error", err);
                }
            });
        }

        this.$root.$on('djembe-play-notes', (notes, repeat) => {
            this.play(notes, repeat);
        });
        this.getUserList();
        let self = this;
        this.getSongList().then(
            function(){
                // detect current route
                if (self.$route.params.partid){ // direct access to a specific song
                    let songid = self.songnameToSongid(self.$route.params.partid);
                    // console.log("self.$route.params.partid", self.$route.params.partid);
                    // console.log("songid", songid);
                    if (songid){
                        self.getSong(songid);
                    }
                    else{
                        Notify.create({ message: "Partition '"+self.$route.params.partid+"' non trouvée dans la base de données.", color: 'negative', timeout:0 })
                    }
                }
            },
            function(err){
                console.log("Error here", err);
            }
        );
        Notify.setDefaults({
            position: 'top-right',
            timeout: 2500,
            textColor: 'white',
            actions: [{ icon: 'close', color: 'white' }]
        });
    },
}
</script>

<style>
@font-face {
    font-family: djembe;
    src: url(../assets/fonts/Djembe.ttf);
}
.monospace {
    font-family: monospace;
}
pre {
    display: inline-block;
}
.clickable {
    cursor: pointer;
}
div.shortcut {
    display:inline-block;
    border:1px solid Gray;
    margin-right:10px;
}
div.shortcut > span:first-child {
    padding-left:10px;
    padding-right:10px;
}
div.shortcut > span:last-child {
    background: #ddd;
}
th, td {
    vertical-align: top;
    text-align:left;
}
th {
    padding-left:1em;
    padding-right:1em;
}

.song-content {
    height:calc(100vh - 50px);
    display:flex;
    flex-direction:column;
}

.print-full-width {
    overflow:auto;
    flex:1 1 auto;
    white-space: normal;
}

@media print{
    * {
        overflow: visible;
    }
    #app {
        min-height: unset;
        overflow: visible;
    }
    .q-splitter__panel.q-splitter__before,
    .q-splitter__separator {
        display:none;
    }
    .q-splitter__panel.q-splitter__after {
        width: 100%;
    }
    .noprint {
        display: none;
    }
    .print-full-width {
        width: 100vw;
        display: block;
        position: absolute;
        overflow: visible;
        top: 0;
        left: 0;
    }
    .q-splitter__panel.q-splitter__after,
    .song-content {
        height: unset;
        width: 100%;
        display: block;
        overflow: visible;
    }
}

</style>